import {
  ContatoModel,
  LocalizacaoModel,
  VeiculoModel,
  TransportePessoasModel,
  ServicoDetalhadoModel
} from "./";

export class ServicoDetalhado implements ServicoDetalhadoModel {
  id: number;
  idPrestador: number;
  idCliente: number;
  tipoServico: string;
  motivo: string;
  associadoNoLocal: boolean;
  nomeSolicitante: string;
  contato: ContatoModel;
  status: string;
  statusPrestador: string;
  localizacao: LocalizacaoModel;
  destino: LocalizacaoModel;
  veiculo: VeiculoModel;
  transportePessoas: TransportePessoasModel;
  motivoEstorno: string;
  valorEstornado: number;
  solicitacoesPrestadores: any;
  aceitaReenvioSolicitacao: boolean;
  servicoFrota: any;
  rodaTravada: boolean;
  liberadoRemocao: boolean;
  tipoLocalRemocao: string;

  constructor() {
    this.id = 0;
    this.idCliente = 0;
    this.idPrestador = 0;
    this.tipoServico = '';
    this.motivo = '';
    this.motivoEstorno = '';
    this.valorEstornado = 0;
    this.solicitacoesPrestadores = [];
    this.associadoNoLocal = false;
    this.aceitaReenvioSolicitacao = false;
    this.nomeSolicitante = '';
    this.status = '';
    this.statusPrestador = '';
    this.contato = {
      nome: '',
      dddTelefone: 0,
      numeroTelefone: ''
    };
    this.localizacao = {
      latitude: 0,
      longitude: 0,
      endereco: {
        cep: '',
        tipoEndereco: {
          nome: '',
          descricao: ''
        },
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia:''
      },
      nomeResponsavel: '',
      telefoneResponsavel: ''
    };
    this.destino = {
      latitude: 0,
      longitude: 0,
      endereco: {
        cep: '',
        tipoEndereco: {
          nome: '',
          descricao: ''
        },
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia:'',
      },
      nomeResponsavel: '',
      telefoneResponsavel: ''
    };
    this.veiculo = {
      tipoVeiculo: '',
      placa: '',
      fotos: []
    };
    this.transportePessoas = {
      quantidadePessoas: 0,
      limitacao: false,
      acamado: false,
      operado: false,
      outraLimitacao: '',
      observacao: '',
    };  
    this.servicoFrota = [];  
    this.rodaTravada = false;
    this.liberadoRemocao = true;
    this.tipoLocalRemocao = ''; 
  }
}
